import React, { createContext, useContext, useState, useMemo, ReactNode } from 'react';
import { AppConfigs } from '../types/decisions';

interface AppConfigsContextType {
    appConfigs: AppConfigs;
    setAppConfigs: React.Dispatch<React.SetStateAction<AppConfigs>>;
}

const AppConfigsContext = createContext<AppConfigsContextType | null>(null);

interface AppConfigsProviderProps {
    children: ReactNode;
}

export const AppConfigProvider = ({ children }: AppConfigsProviderProps) => {
    const [ appConfigs, setAppConfigs ] = useState<AppConfigs>({
        inferenceRank: 'ThumbsUp',
        journey: 'All',
        show: {
            progressbar: true,
            header: true,
            footer: true,
            headerMenu: true,
            menuItems: {
                importance: false,
                settings: false,
                reset: false,
                decide: false,
                additionalItems: [],
                externalItems: [],
            },
            copyLabel: 'Copy Patient Version',
            formTitle: 'Fill in the form',
            rightTitle: '',
            insert: 'Submit',
            update: 'Save',
            cancel: 'Reset',
            delete: 'Delete',
        },
        criteriaSettings: {
            tradeoffs: 'SliderBarHorizontal',
            popup: {
                show: true,
                threshold: 0,
            },
            enumerated: 'Slider',
            number: 'Scale',
            zipcode: 'SingleField',
            longLat: 'SingleField',
            date: 'DatePicker',
            color: 'SingleColor',
        },
    });

    const value = useMemo(() => (
        { appConfigs, setAppConfigs }
    ), [ appConfigs ]);

    return (
        <AppConfigsContext.Provider value={value}>
            {children}
        </AppConfigsContext.Provider>
    );
};

export const useAppConfig = () => {
    const context = useContext(AppConfigsContext);
    if (!context) {
        throw new Error('useAppConfig must be used within a AppConfigProvider');
    }
    return context;
};